import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { CatalogoResponse } from "../interface/catalogo-problemas.interface";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'

})
export class CatalogoProblemasService {
  private readonly apiUrl = environment.socketUrl
  constructor(private http: HttpClient) {

  }

  loadCatalogo(): Observable<CatalogoResponse> {

    return this.http.get<CatalogoResponse>(`${this.apiUrl}/catalogo`);
  }

}
